<template>
  <div @click="handleClickBtn" class="count-down-bg" :class="[{ green: greenText }, { blue: blueText }, { disabled: disabled }]">
    <span v-show="disabled" class="second">{{ time }}s</span>
    <span class="time">{{ text }}</span>
  </div>
</template>
<script>
/**
 * countDown 获取短信验证码倒计时
 * @event start 开始倒计时
 */
export default {
  props: {
    totalTime: {
      // 总时间
      type: Number,
      default: 90,
    },
    greenText: {
      type: Boolean,
      default: false,
    },
    blueText: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disabled: false, // 是否可用, 默认可用
      time: this.totalTime, // 倒计时时间
      text: '获取验证码', // 倒计时内容
    }
  },
  watch: {
    time() {
      if (this.time === this.totalTime) {
        this.text = '获取验证码'
        this.disabled = false
      } else if (this.time === 0) {
        this.text = '重发'
        this.disabled = false
      } else if (this.time > 0) {
        this.text = '后重发'
        this.disabled = true
      }
    },
  },
  methods: {
    handleClickBtn() {
      if (!this.disabled) {
        this.$emit('clickBtn')
      }
    },
    start() {
      // 启动
      this.time = this.totalTime
      this.runTime()
    },
    runTime() {
      // 倒计时
      if (this.time > 0) {
        this.time--
        setTimeout(() => {
          this.runTime()
        }, 1000)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.count-down-bg {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  white-space: nowrap;
  &.green {
    color: #23cc77;
    font-size: 0.3rem;
  }
  &.blue {
    color: #35495e;
    font-size: 0.28rem;
  }
  &:active,
  &.disabled {
    opacity: 0.3;
  }
}
</style>
